var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJod = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30486 8.09344H23.2541C21.5586 3.52383 17.16 0.267334 12.0005 0.267334C8.68673 0.267334 5.68706 1.61072 3.51562 3.78244L7.30486 8.09344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30486 16.4431H23.2541C21.5586 21.0127 17.16 24.2692 12.0005 24.2692C8.68673 24.2692 5.68706 22.9258 3.51562 20.7541L7.30486 16.4431Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 3.78296C-1.17157 8.46924 -1.17157 16.0673 3.51471 20.7536C5.45126 18.817 7.31375 16.9546 12 12.2683L3.51471 3.78296Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76366 9.65796L5.4222 11.0351L6.9095 10.6914L6.24341 12.0648L7.43942 13.0133L5.95034 13.3489L5.95447 14.8753L4.76366 13.9203L3.5728 14.8753L3.57697 13.3489L2.08789 13.0133L3.28386 12.0648L2.61786 10.6914L4.10506 11.0351L4.76366 9.65796Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJod);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/JOD.580b72434afebe1b50df660c91f64fdb.svg";